import { ChartSettings } from '../../../chart-settings/model';
import { ThroughputMonitoredServiceQuery } from '../../config';
import { NetworkServiceBitrateApiModel } from '../../model';
import { AxiosInstanceProvider } from '../../../../core/hooks';

export interface GetNetworkServiceBitratesPayloadModel {
  customerId: number;
  itemId: number;
  chartSettings: ChartSettings;
}

type GetNetworkServiceBitratesHttpGetResponseModel = NetworkServiceBitrateApiModel[];

export const getBitrateMeasurements = async (
  provideAxios: AxiosInstanceProvider,
  { customerId, itemId, chartSettings }: GetNetworkServiceBitratesPayloadModel,
): Promise<GetNetworkServiceBitratesHttpGetResponseModel> => {
  const apiUrl = ThroughputMonitoredServiceQuery['GetNetworkServiceBitrates'].url
    .replace('{customerId}', customerId.toString(10))
    .replace('{itemId}', itemId.toString(10));
  const params = {
    timespan: chartSettings.timespan,
    resolution: chartSettings.resolution,
  };
  const response = await provideAxios()
    .get<GetNetworkServiceBitratesHttpGetResponseModel>(apiUrl, { params });
  return response.data;
};